<div (click)="window.innerWidth <= mobileMaxWidth ? openDatePickerModal() : menuTrigger.openMenu()">
  <div #contentSlot>
    <ng-content></ng-content>
  </div>

  @if (!contentSlot.children.length) {
    <lla-selector-card [label]="label" [value]="formattedDate" [extraClasses]="extraClasses"></lla-selector-card>
  }
</div>

<div
  [matMenuTriggerFor]="datePickerMenu"
  #menuTrigger="matMenuTrigger"
  (menuOpened)="onMenuOpened()"
  (menuClosed)="setSelectedDate(); menuIsOpen = false"
></div>

<mat-menu
  #datePickerMenu="matMenu"
  [hasBackdrop]="true"
  backdropClass="mg-menu-backdrop"
  class="lla-filter-menu-full"
>
  <div
    class="flex-1 flex flex-col overflow-auto w-full md:w-[442px]"
    (click)="$event.stopPropagation()"
    (keydown.Tab)="$event.stopPropagation()"
  >
    @if (menuIsOpen) {
      <lla-date-picker
        [value]="selectedValue"
        [maxDate]="maxDate"
        [minDate]="minDate"
        [label]="label"
        (valueChanged)="onValueChanged($event); menuTrigger.closeMenu()"
        (cancelled)="menuTrigger.closeMenu()"
      ></lla-date-picker>
    }
  </div>
</mat-menu>
